import { createSelector } from '@ngrx/store';
import { State } from './spaycial-integration-reducer';
import { State as AppState } from '@app/core/store/reducers';

export const spaycialIntegration = (state: AppState): State => state.spaycialIntegration;

export const selectStatus = createSelector(spaycialIntegration, (state: State) => state.status);
export const scanUser = createSelector(spaycialIntegration, (state: State) => state.scanUser && !state.status);
export const selectRedirectUrl = createSelector(spaycialIntegration, (state: State) => state.redirectUrl);
export const selectError = createSelector(spaycialIntegration, (state: State) => state.error);
